import React from 'react';
import { Box, Loader, Text, Title, VerticalBox } from '../../components';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { COLORS, device, ROUTES } from '../../constants';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from '../../types/globalTypes';
import { fetchHomePageData } from '../../services/home/api';
import { IndustryList } from './partials/IndustryList';
import { MotionText } from '../../components/Motion';

export const Industries = () => {
  const { t } = useTranslation();

  const { isLoading, data, error } = useQuery<
    ApiResponse,
    Error,
    ApiResponse,
    string[]
  >({
    queryKey: ['homePageData'],
    queryFn: fetchHomePageData,
    refetchOnMount: false,
  });

  if (error) {
    return (
      <Box>
        <ErrorWrapper>
          <Text text={error.message} />
        </ErrorWrapper>
      </Box>
    );
  }

  if (!data || isLoading) {
    return <Loader />;
  }

  const { domains } = data.data;

  return (
    <IndustriesWrapper>
      <Box>
        <VerticalBox>
          <TextWrapper>
            <RoutePath>
              <StyledLink to={ROUTES.HOME}>
                <Text
                  size={16}
                  lineHeight={24}
                  color={COLORS.ROUTE_PATH}
                  text={t('screen.home.title')}
                />
              </StyledLink>
              <span>-</span>
              <StyledLink to={ROUTES.INDUSTRIES}>
                <Text
                  size={16}
                  lineHeight={24}
                  color={COLORS.ROUTE_PATH}
                  text={t('screen.home.industries.title')}
                />
              </StyledLink>
            </RoutePath>
            <Title title={t('screen.home.industries.title')} />
          </TextWrapper>
          <IndustryList industries={domains} />
        </VerticalBox>
      </Box>
    </IndustriesWrapper>
  );
};
const ErrorWrapper = styled.div`
  padding: 20px 0;
`;
const IndustriesWrapper = styled.div`
  background-color: ${COLORS.GRAY_BG_COLOR};
`;
const RoutePath = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  span {
    color: ${COLORS.ROUTE_PATH};
  }

  margin-bottom: 40px;
  @media screen and (${device.md}) {
    margin-bottom: 20px;
  }
`;
const StyledLink = styled(Link)`
  text-decoration: none;
  color: #000;
  &:hover {
    h4 {
      color: ${COLORS.MAIN_RED};
      text-decoration: underline;
    }
  }
`;

const TextWrapper = styled(MotionText)``;
